export const de = {
  "Rubrics": "Bewertungsraster",
  "New Rubric": "Neues Raster",
  "Create scoring rubrics for any topic, subject, or assignment": "Erstellen Sie Bewertungsraster für jedes Thema, Fach oder jede Aufgabe",
  "AI Draft": "KI-Entwurf",
  "Start Blank": "Leer beginnen",
  "Topic / what to assess": "Thema / was bewertet wird",
  "Class (optional)": "Klasse (optional)",
  "Title (optional)": "Titel (optional)",
  "Levels": "Stufen",
  "Generate Rubric": "Raster erstellen",
  "Create": "Erstellen",
  "Criteria": "Kriterien",
  "Criterion name": "Name des Kriteriums",
  "Descriptor...": "Deskriptor...",
  "Add Criterion": "Kriterium hinzufügen",
  "Add level": "Stufe hinzufügen",
  "Remove level": "Stufe entfernen",
  "Remove": "Entfernen",
  "Score Student": "Schüler bewerten",
  "Save to Gradebook": "Im Notenbuch speichern",
  "Tap cells below to score": "Tippen Sie auf die Zellen zum Bewerten",
  "Select student": "Schüler auswählen",
  "Select a rubric or create a new one": "Wählen Sie ein Raster oder erstellen Sie ein neues",
  "No rubrics yet. Create your first one!": "Noch keine Raster. Erstellen Sie das erste!",
  "Rubric created!": "Raster erstellt!",
  "Rubric saved": "Raster gespeichert",
  "Rubric deleted": "Raster gelöscht",
  "Rubric duplicated": "Raster dupliziert",
  "Delete this rubric?": "Dieses Raster löschen?",
  "Duplicate": "Duplizieren",
  "No class": "Keine Klasse",
  "Rubric": "Raster",
  "Saved to gradebook": "Im Notenbuch gespeichert",
  "Failed to save score": "Bewertung konnte nicht gespeichert werden",
  "Select a class and student": "Wählen Sie Klasse und Schüler",
  "Failed to create rubric. Please try again.": "Erstellung fehlgeschlagen. Bitte erneut versuchen.",
  "Analyzing the topic...": "Thema wird analysiert...",
  "Defining criteria...": "Kriterien werden definiert...",
  "Writing level descriptors...": "Deskriptoren werden verfasst...",
  "Excellent": "Ausgezeichnet",
  "Good": "Gut",
  "Fair": "Befriedigend",
  "Needs Improvement": "Verbesserungsbedarf",
  "New Level": "Neue Stufe",
  "Total points possible": "Maximal mögliche Punkte",
  "Loading...": "Wird geladen...",
  "Failed to duplicate": "Duplizieren fehlgeschlagen",
  "Send to Google Classroom": "An Google Classroom senden",
  "Opening Google Classroom...": "Google Classroom wird geöffnet...",
  "Failed to share to Classroom": "Teilen mit Classroom fehlgeschlagen",
  "Analyzing standards...": "Standards werden analysiert...",
  "Writing content...": "Inhalt wird verfasst...",
  "Formatting sections...": "Abschnitte werden formatiert...",
  "Finalizing...": "Abschluss...",
  "All Plans": "Alle Pläne",
  "Color": "Farbe",
  "Current": "Aktuell",
  "Delete": "Löschen",
  "Delete this folder? Plans will be moved to \"Unfiled\"": "Diesen Ordner löschen? Die Pläne werden nach „Ohne Ordner“ verschoben",
  "Edit": "Bearbeiten",
  "Edit Folder": "Ordner bearbeiten",
  "Error creating folder": "Fehler beim Erstellen des Ordners",
  "Error deleting folder": "Fehler beim Löschen des Ordners",
  "Error moving plan": "Fehler beim Verschieben des Plans",
  "Error updating folder": "Fehler beim Aktualisieren des Ordners",
  "Ex: Math 5th Grade": "z. B. Mathe 5. Klasse",
  "Folder created": "Ordner erstellt",
  "Folder deleted": "Ordner gelöscht",
  "Folder name": "Ordnername",
  "Folder updated": "Ordner aktualisiert",
  "Folders": "Ordner",
  "Move to folder": "In Ordner verschieben",
  "New Folder": "Neuer Ordner",
  "No objective defined": "Kein Ziel definiert",
  "No unfiled plans": "Keine Pläne ohne Ordner",
  "Plan moved": "Plan verschoben",
  "This folder is empty": "Dieser Ordner ist leer",
  "Unfiled": "Ohne Ordner",
  "You don't have any lesson plans": "Sie haben noch keine Unterrichtspläne",
  "Your lesson plans": "Ihre Unterrichtspläne",
  "Take Attendance": "Anwesenheit erfassen",
  "You have": "Sie haben",
  "class(es) without attendance today": "Klasse(n) ohne Anwesenheit heute",
  "Student Intervention Needed": "Schülerintervention erforderlich",
  "student(s) showing significant struggles - consider reaching out": "Schüler mit erheblichen Schwierigkeiten - Kontaktaufnahme empfohlen",
  "Overdue Grading": "Überfällige Korrekturen",
  "assignment(s) past due date need grading": "überfällige Aufgabe(n) zu korrigieren",
  "Plan Next Week": "Nächste Woche planen",
  "class(es) don't have lessons planned for next week": "Klasse(n) ohne geplante Stunden für nächste Woche",
  "10th Grade": "10. Klasse",
  "11th Grade": "11. Klasse",
  "12th Grade": "12. Klasse",
  "1st Grade": "1. Klasse",
  "2nd Grade": "2. Klasse",
  "3rd Grade": "3. Klasse",
  "4th Grade": "4. Klasse",
  "5th Grade": "5. Klasse",
  "6th Grade": "6. Klasse",
  "7th Grade": "7. Klasse",
  "8th Grade": "8. Klasse",
  "9th Grade": "9. Klasse",
  "AI Assignment generated": "KI-Aufgabe erstellt",
  "AI Assignments": "KI-Aufgaben",
  "AI Assistant": "KI-Assistent",
  "AI Generated": "KI-generiert",
  "AI Grading": "KI-Korrektur",
  "AI Recommendations": "KI-Empfehlungen",
  "AI Suggestions": "KI-Vorschläge",
  "AI Teaching Assistant": "KI-Lehrassistent",
  "Access Link": "Zugangslink",
  "Access resources to help plan your lessons": "Greifen Sie auf Ressourcen zur Unterrichtsplanung zu",
  "Activity Ideas": "Aktivitätsideen",
  "Adapt": "Anpassen",
  "Adapt with AI": "Mit KI anpassen",
  "Adaptive Learning": "Adaptives Lernen",
  "Add": "Hinzufügen",
  "Add New Category": "Neue Kategorie hinzufügen",
  "Add Question": "Frage hinzufügen",
  "Add option": "Option hinzufügen",
  "Add pair": "Paar hinzufügen",
  "Add to Calendar": "Zum Kalender hinzufügen",
  "Additional Instructions (optional)": "Zusätzliche Anweisungen (optional)",
  "Additional Notes": "Zusätzliche Notizen",
  "Additional instructions": "Zusätzliche Anweisungen",
  "Additional notes...": "Zusätzliche Notizen...",
  "All caught up!": "Alles erledigt!",
  "All semesters": "Alle Semester",
  "All students on track!": "Alle Schüler auf Kurs!",
  "All suggestions applied": "Alle Vorschläge übernommen",
  "Analysis took too long. Please try again.": "Die Analyse hat zu lange gedauert. Bitte erneut versuchen.",
  "Analyzing PDF with AI... This may take up to a minute.": "PDF wird mit KI analysiert... Dies kann bis zu einer Minute dauern.",
  "Analyzing...": "Analysiere...",
  "Answer Key": "Lösungsschlüssel",
  "Answer:": "Antwort:",
  "Apply All": "Alle übernehmen",
  "Apply as-is": "Unverändert übernehmen",
  "Apply to notes": "Auf Notizen anwenden",
  "Approve & Publish": "Genehmigen & Veröffentlichen",
  "Art": "Kunst",
  "Ask me about planning, standards, teaching strategies...": "Fragen Sie mich zu Planung, Standards, Unterrichtsstrategien...",
  "Assessment": "Bewertung",
  "Assignment List": "Aufgabenliste",
  "Assignment created": "Aufgabe erstellt",
  "Assignment created!": "Aufgabe erstellt!",
  "Assignment created. Student link copied to clipboard.": "Aufgabe erstellt. Schülerlink in die Zwischenablage kopiert.",
  "Assignment deleted": "Aufgabe gelöscht",
  "Assignment name": "Aufgabenname",
  "Assignment updated": "Aufgabe aktualisiert",
  "Assignments & Gradebook": "Aufgaben & Notenbuch",
  "Assignments to Grade": "Zu korrigierende Aufgaben",
  "At Risk": "Gefährdet",
  "Attendance": "Anwesenheit",
  "Attendance Rpt": "Anwesenheitsbericht",
  "Attendance saved": "Anwesenheit gespeichert",
  "Automate your entire Sunday night prep with a single prompt": "Automatisieren Sie Ihre gesamte Sonntagabend-Vorbereitung mit einer einzigen Eingabe",
  "Back": "Zurück",
  "Based on grades & attendance": "Basierend auf Noten & Anwesenheit",
  "Bilingual": "Zweisprachig",
  "Both (CC + PR)": "Beide (CC + PR)",
  "Briefly describe what makes this lesson structure successful...": "Beschreiben Sie kurz, was diese Unterrichtsstruktur erfolgreich macht...",
  "Build Questions": "Fragen erstellen",
  "CC + PR": "CC + PR",
  "Calendar": "Kalender",
  "Calendar Events": "Kalenderereignisse",
  "Cancel": "Abbrechen",
  "Cannot delete category with assignments": "Kategorie mit Aufgaben kann nicht gelöscht werden",
  "Categories": "Kategorien",
  "Category": "Kategorie",
  "Category created": "Kategorie erstellt",
  "Category deleted": "Kategorie gelöscht",
  "Category updated": "Kategorie aktualisiert",
  "Chat": "Chat",
  "Chat with AI Assistant": "Mit dem KI-Assistenten chatten",
  "Choose File": "Datei auswählen",
  "Class": "Klasse",
  "Class created": "Klasse erstellt",
  "Class deleted": "Klasse gelöscht",
  "Class updated": "Klasse aktualisiert",
  "Classes Today": "Unterricht heute",
  "Close": "Schließen",
  "Closure": "Abschluss",
  "Column A": "Spalte A",
  "Column B": "Spalte B",
  "Complete required fields": "Pflichtfelder ausfüllen",
  "Connecting to server... Retrying": "Verbindung zum Server... Erneuter Versuch",
  "Content generated! Use the Save button to save it.": "Inhalt erstellt! Verwenden Sie die Schaltfläche Speichern.",
  "Convert to Online Test": "In Online-Test umwandeln",
  "Copied!": "Kopiert!",
  "Copy": "Kopieren",
  "Copy Link": "Link kopieren",
  "Copy link": "Link kopieren",
  "Copy student link": "Schülerlink kopieren",
  "Core": "Kernfach",
  "Correct answer": "Richtige Antwort",
  "Create assessments with answers": "Erstellen Sie Tests mit Lösungen",
  "Create with AI": "Mit KI erstellen",
  "Created with TeacherHubPro - AI Assistant for Teachers": "Erstellt mit TeacherHubPro - KI-Assistent für Lehrkräfte",
  "Creative classroom activities": "Kreative Unterrichtsaktivitäten",
  "Current Categories": "Aktuelle Kategorien",
  "Customized template applied!": "Angepasste Vorlage übernommen!",
  "Dark": "Dunkel",
  "Dark mode": "Dunkelmodus",
  "Date Range (2 Weeks)": "Zeitraum (2 Wochen)",
  "Date of Test/Quiz": "Datum des Tests/Quiz",
  "Day theme...": "Tagesthema...",
  "Delete this assignment?": "Diese Aufgabe löschen?",
  "Delete this prep batch?": "Diese Vorbereitung löschen?",
  "Delete this template?": "Diese Vorlage löschen?",
  "Deleted": "Gelöscht",
  "Describe the learning goal...": "Beschreiben Sie das Lernziel...",
  "Describe what you need to prep and the agent will generate everything automatically": "Beschreiben Sie, was Sie vorbereiten müssen, und der Agent erstellt alles automatisch",
  "Describe your lesson and AI will generate a standards-based plan.": "Beschreiben Sie Ihre Stunde und die KI erstellt einen standardbasierten Plan.",
  "Description": "Beschreibung",
  "Description / Instructions": "Beschreibung / Anweisungen",
  "Differentiation strategies": "Differenzierungsstrategien",
  "Difficulty": "Schwierigkeit",
  "Done": "Fertig",
  "Due Date (optional)": "Fälligkeitsdatum (optional)",
  "Due:": "Fällig:",
  "Duration (minutes)": "Dauer (Minuten)",
  "E.g., Decimal multiplication": "z. B. Dezimalmultiplikation",
  "E.g., Equivalent fractions": "z. B. Gleichwertige Brüche",
  "E.g., Focus on word problems...": "z. B. Fokus auf Textaufgaben...",
  "E.g., Fractions Plan - 4th Grade": "z. B. Brüche-Plan - 4. Klasse",
  "E.g., Fractions with different denominators": "z. B. Brüche mit verschiedenen Nennern",
  "E.g., Fractions, American Revolution...": "z. B. Brüche, Amerikanische Revolution...",
  "E.g., math, fractions, hands-on": "z. B. Mathe, Brüche, praktisch",
  "ELA": "Deutsch/Sprache",
  "Easy": "Leicht",
  "Edit Assignment": "Aufgabe bearbeiten",
  "Edit Class": "Klasse bearbeiten",
  "Edit Parent Email": "Eltern-E-Mail bearbeiten",
  "Edit class": "Klasse bearbeiten",
  "Educational Games": "Lernspiele",
  "End": "Ende",
  "English": "Englisch",
  "English/Reading": "Englisch/Lesen",
  "Enjoy your day off": "Genießen Sie Ihren freien Tag",
  "Enrichment": "Vertiefung",
  "Enter a topic": "Thema eingeben",
  "Enter question...": "Frage eingeben...",
  "Enter your prep request": "Geben Sie Ihre Vorbereitungsanfrage ein",
  "Error applying template": "Fehler beim Anwenden der Vorlage",
  "Error creating class": "Fehler beim Erstellen der Klasse",
  "Error customizing": "Fehler bei der Anpassung",
  "Error deleting": "Fehler beim Löschen",
  "Error exporting calendar": "Fehler beim Exportieren des Kalenders",
  "Error generating link": "Fehler beim Erstellen des Links",
  "Error generating plan": "Fehler beim Erstellen des Plans",
  "Error generating suggestions": "Fehler beim Erstellen der Vorschläge",
  "Error generating weekly plan": "Fehler beim Erstellen des Wochenplans",
  "Error loading AI assignments": "Fehler beim Laden der KI-Aufgaben",
  "Error loading template": "Fehler beim Laden der Vorlage",
  "Error loading templates": "Fehler beim Laden der Vorlagen",
  "Error saving template": "Fehler beim Speichern der Vorlage",
  "Error sending email": "Fehler beim Senden der E-Mail",
  "Essay": "Aufsatz",
  "Essay answers are graded manually": "Aufsätze werden manuell bewertet",
  "Everything published successfully!": "Alles erfolgreich veröffentlicht!",
  "Ex: Chapter 1 - Vocabulary": "z. B. Kapitel 1 - Wortschatz",
  "Ex: English": "z. B. Englisch",
  "Ex: Greetings and Introductions": "z. B. Begrüßungen und Vorstellungen",
  "Ex: Prep next week for Unit 3 History (Civil War), matching state curriculum standards": "z. B. Nächste Woche für Einheit 3 Geschichte (Bürgerkrieg) vorbereiten, gemäß Lehrplanstandards",
  "Ex: Unit 1": "z. B. Einheit 1",
  "Expiration (days)": "Ablauf (Tage)",
  "Expires:": "Läuft ab:",
  "Failed to delete": "Löschen fehlgeschlagen",
  "Failed to generate assignment": "Aufgabenerstellung fehlgeschlagen",
  "Failed to generate content. Please try again.": "Inhaltserstellung fehlgeschlagen. Bitte erneut versuchen.",
  "Failed to load data": "Daten konnten nicht geladen werden",
  "Failed to parse PDF": "PDF konnte nicht verarbeitet werden",
  "Failed to publish": "Veröffentlichung fehlgeschlagen",
  "Failed to save": "Speichern fehlgeschlagen",
  "Failed to start agent": "Agent konnte nicht gestartet werden",
  "Failed to upload file": "Datei-Upload fehlgeschlagen",
  "False": "Falsch",
  "File uploaded": "Datei hochgeladen",
  "Fill Blank": "Lückentext",
  "First and last name required": "Vor- und Nachname erforderlich",
  "Friday Quiz": "Freitagsquiz",
  "From": "Von",
  "Full weekly plan generated! Review each day.": "Kompletter Wochenplan erstellt! Überprüfen Sie jeden Tag.",
  "Generate": "Erstellen",
  "Generate Assignment": "Aufgabe erstellen",
  "Generate Assignment with AI": "Aufgabe mit KI erstellen",
  "Generate Content": "Inhalt erstellen",
  "Generate Full Week": "Ganze Woche erstellen",
  "Generate Plan": "Plan erstellen",
  "Generate Plan with AI": "Plan mit KI erstellen",
  "Generate a structured weekly lesson plan with objectives, daily activities, and materials.": "Erstellen Sie einen strukturierten Wochenplan mit Zielen, täglichen Aktivitäten und Materialien.",
  "Generate a weekly plan with AI and save it as a template": "Erstellen Sie einen Wochenplan mit KI und speichern Sie ihn als Vorlage",
  "Generate complete lesson plans": "Erstellen Sie komplette Unterrichtspläne",
  "Generate content and use the \"Save Content\" button to save it here": "Erstellen Sie Inhalte und speichern Sie sie hier mit der Schaltfläche „Inhalt speichern“",
  "Generate materials based on National Standards, instantly.": "Erstellen Sie sofort Materialien nach nationalen Standards.",
  "Generate practice worksheets": "Erstellen Sie Übungsblätter",
  "Generate with AI": "Mit KI erstellen",
  "Generated Content": "Erstellter Inhalt",
  "Generated Questions": "Erstellte Fragen",
  "Generated content will appear here": "Der erstellte Inhalt erscheint hier",
  "Generated with AI Assistant": "Mit dem KI-Assistenten erstellt",
  "Generating content...": "Inhalt wird erstellt...",
  "Generating link...": "Link wird erstellt...",
  "Generating week...": "Woche wird erstellt...",
  "Generating...": "Wird erstellt...",
  "Generation failed.": "Erstellung fehlgeschlagen.",
  "Generation failed. Please try again.": "Erstellung fehlgeschlagen. Bitte erneut versuchen.",
  "Generation timed out": "Zeitüberschreitung bei der Erstellung",
  "Generation took too long. Please try again.": "Die Erstellung hat zu lange gedauert. Bitte erneut versuchen.",
  "Geography": "Erdkunde",
  "Get detailed topic summaries": "Erhalten Sie detaillierte Themenzusammenfassungen",
  "Go to SM Aprendizaje": "Zu SM Aprendizaje",
  "Grade": "Klasse",
  "Grade Level": "Klassenstufe",
  "Grade Level *": "Klassenstufe *",
  "Grade Report": "Notenbericht",
  "Grade Scale": "Notenskala",
  "Gradebook": "Notenbuch",
  "Grades": "Noten",
  "Hard": "Schwer",
  "Health": "Gesundheit",
  "Hi! I'm your AI assistant.": "Hallo! Ich bin Ihr KI-Assistent.",
  "High": "Hoch",
  "History": "Geschichte",
  "Hook/Intro": "Einstieg/Intro",
  "How do I teach fractions?": "Wie unterrichte ich Brüche?",
  "How to capture attention...": "Wie man Aufmerksamkeit gewinnt...",
  "How to close the lesson...": "Wie man die Stunde abschließt...",
  "I can help you with lesson planning, teaching strategies, and questions about standards.": "Ich helfe Ihnen bei Unterrichtsplanung, Lehrstrategien und Fragen zu Standards.",
  "Ideas for reading activities": "Ideen für Leseaktivitäten",
  "Instructions for students...": "Anweisungen für Schüler...",
  "Instructions for this question (optional)...": "Anweisungen für diese Frage (optional)...",
  "Instructions:": "Anweisungen:",
  "Integration with other subjects": "Fächerübergreifende Integration",
  "Item": "Element",
  "Kindergarten": "Kindergarten",
  "Language": "Sprache",
  "Learning Goal": "Lernziel",
  "Learning Objective/s": "Lernziel(e)",
  "Lesson Date Range": "Unterrichtszeitraum",
  "Lesson Plan": "Unterrichtsplan",
  "Lesson Templates": "Unterrichtsvorlagen",
  "Lesson Topic": "Unterrichtsthema",
  "Lessons": "Stunden",
  "Light": "Hell",
  "Light mode": "Hellmodus",
  "Link copied": "Link kopiert",
  "Link copied to clipboard": "Link in die Zwischenablage kopiert",
  "Link copied!": "Link kopiert!",
  "List of materials...": "Materialliste...",
  "Loading templates...": "Vorlagen werden geladen...",
  "Low": "Niedrig",
  "Manage Grade Categories": "Notenkategorien verwalten",
  "Manage your classes and students": "Verwalten Sie Ihre Klassen und Schüler",
  "Manual Assignments": "Manuelle Aufgaben",
  "Match": "Zuordnung",
  "Match:": "Ordnen Sie zu:",
  "Matching": "Zuordnung",
  "Materials Needed": "Benötigte Materialien",
  "Math": "Mathe",
  "Mathematics": "Mathematik",
  "Medium": "Mittel",
  "Multiple Choice": "Multiple Choice",
  "Music": "Musik",
  "My Prep Batches": "Meine Vorbereitungen",
  "My Templates": "Meine Vorlagen",
  "Name (English)": "Name (Englisch)",
  "Name (Spanish)": "Name (Spanisch)",
  "Name is required": "Name ist erforderlich",
  "New Lesson": "Neue Stunde",
  "New Weekly Prep": "Neue Wochenvorbereitung",
  "New chat": "Neuer Chat",
  "No assignments": "Keine Aufgaben",
  "No assignments created": "Keine Aufgaben erstellt",
  "No categories. Create one to get started.": "Keine Kategorien. Erstellen Sie eine, um zu beginnen.",
  "No classes today": "Heute kein Unterricht",
  "No classes yet": "Noch keine Klassen",
  "No content to save": "Kein Inhalt zum Speichern",
  "No email generated": "Keine E-Mail erstellt",
  "No pending assignments": "Keine ausstehenden Aufgaben",
  "No prep batches yet": "Noch keine Vorbereitungen",
  "No questions found in the PDF": "Keine Fragen im PDF gefunden",
  "No questions to print": "Keine Fragen zum Drucken",
  "No quiz generated": "Kein Quiz erstellt",
  "No risk alerts at this time": "Derzeit keine Risikowarnungen",
  "No saved plans yet": "Noch keine gespeicherten Pläne",
  "No saved templates": "Keine gespeicherten Vorlagen",
  "No students": "Keine Schüler",
  "No students in this class": "Keine Schüler in dieser Klasse",
  "No students yet": "Noch keine Schüler",
  "No suggestions to save": "Keine Vorschläge zum Speichern",
  "Number of Questions": "Anzahl der Fragen",
  "Number of questions": "Anzahl der Fragen",
  "Open Portal": "Portal öffnen",
  "Option": "Option",
  "Optional: add specific details...": "Optional: spezifische Details hinzufügen...",
  "Or adapt for your specific topic:": "Oder passen Sie es an Ihr Thema an:",
  "Or create a new prep batch above": "Oder erstellen Sie oben eine neue Vorbereitung",
  "Or customize for new topic:": "Oder für ein neues Thema anpassen:",
  "Original topic:": "Ursprüngliches Thema:",
  "Other": "Sonstiges",
  "Overdue": "Überfällig",
  "Parent Email": "Eltern-E-Mail",
  "Parent Portal": "Elternportal",
  "Period": "Stunde",
  "Physical Education": "Sport",
  "Plan Title": "Plantitel",
  "Plan Type": "Plantyp",
  "Plan created": "Plan erstellt",
  "Plan deleted": "Plan gelöscht",
  "Plan duplicated": "Plan dupliziert",
  "Plan generated! Review and edit as needed.": "Plan erstellt! Überprüfen und bei Bedarf bearbeiten.",
  "Plan saved!": "Plan gespeichert!",
  "Plan updated": "Plan aktualisiert",
  "Play to Learn": "Spielend lernen",
  "Please add an objective or topic first to generate suggestions": "Bitte fügen Sie zuerst ein Ziel oder Thema hinzu, um Vorschläge zu erstellen",
  "Please add an objective or topic first to generate the weekly plan": "Bitte fügen Sie zuerst ein Ziel oder Thema hinzu, um den Wochenplan zu erstellen",
  "Please allow pop-ups to print": "Bitte erlauben Sie Pop-ups zum Drucken",
  "Please enter a new topic": "Bitte geben Sie ein neues Thema ein",
  "Please fill in all fields": "Bitte füllen Sie alle Felder aus",
  "Please fill in all required fields": "Bitte füllen Sie alle Pflichtfelder aus",
  "Please respond in English.": "Please respond in German.",
  "Prep Agent": "Vorbereitungsagent",
  "Prep agent started": "Vorbereitungsagent gestartet",
  "Prep failed": "Vorbereitung fehlgeschlagen",
  "Presentations": "Präsentationen",
  "Pricing": "Preise",
  "Print": "Drucken",
  "Print / PDF": "Drucken / PDF",
  "Print / Save PDF": "Drucken / Als PDF speichern",
  "Published": "Veröffentlicht",
  "Question Types": "Fragetypen",
  "Quick Actions": "Schnellaktionen",
  "Quiz/Assessment": "Quiz/Bewertung",
  "Quiz/Test": "Quiz/Test",
  "Ready for review": "Bereit zur Überprüfung",
  "Regenerate": "Neu erstellen",
  "Report Cards": "Zeugnisse",
  "Save": "Speichern",
  "Save & Get Student Link": "Speichern & Schülerlink erhalten",
  "Save Changes": "Änderungen speichern",
  "Save Content": "Inhalt speichern",
  "Save Template": "Vorlage speichern",
  "Save as Template": "Als Vorlage speichern",
  "Save this plan to reuse with different topics": "Speichern Sie diesen Plan zur Wiederverwendung mit anderen Themen",
  "Saved": "Gespeichert",
  "Saved Lesson Plans": "Gespeicherte Unterrichtspläne",
  "Saved Content": "Gespeicherte Inhalte",
  "ESL Support": "ESL-Unterstützung",
  "Rubric adapted for English learners (WIDA + PR standards)": "Rubrik angepasst für Englischlernende (WIDA- + PR-Standards)",
  "Generate ESL-level material for English learners (WIDA + PR standards)": "Erstellt ESL-Material für Englischlernende (WIDA- + PR-Standards)",
  "Saved on": "Gespeichert am",
  "Schedule will appear in your Command Center": "Der Stundenplan erscheint in Ihrer Kommandozentrale",
  "Science": "Naturwissenschaften",
  "Select Tool": "Werkzeug auswählen",
  "Select a category": "Kategorie auswählen",
  "Select a class": "Klasse auswählen",
  "Select a class to view its students": "Wählen Sie eine Klasse, um ihre Schüler zu sehen",
  "Select a prep batch to view details": "Wählen Sie eine Vorbereitung, um Details zu sehen",
  "Select class": "Klasse auswählen",
  "Select...": "Auswählen...",
  "Semester": "Semester",
  "Send Email": "E-Mail senden",
  "Send via Email": "Per E-Mail senden",
  "Sending...": "Wird gesendet...",
  "Share this link with the student's parents. The portal is read-only.": "Teilen Sie diesen Link mit den Eltern des Schülers. Das Portal ist schreibgeschützt.",
  "Short Answer": "Kurzantwort",
  "Skill...": "Fähigkeit...",
  "Slides": "Folien",
  "Social Studies": "Sozialkunde",
  "Spanish": "Spanisch",
  "Specify other activity...": "Andere Aktivität angeben...",
  "Specify other material...": "Anderes Material angeben...",
  "Standards": "Standards",
  "Standards Framework": "Standards-Rahmenwerk",
  "Start": "Beginn",
  "Start Prep Agent": "Vorbereitungsagent starten",
  "Starter": "Starter",
  "Starter Templates": "Starter-Vorlagen",
  "Story title": "Titel der Geschichte",
  "Student": "Schüler",
  "Student PDF": "Schüler-PDF",
  "Student Progress": "Schülerfortschritt",
  "Student added": "Schüler hinzugefügt",
  "Student deleted": "Schüler gelöscht",
  "Student updated": "Schüler aktualisiert",
  "Students at Risk": "Gefährdete Schüler",
  "Sub Packet": "Vertretungspaket",
  "Subject": "Fach",
  "Subject *": "Fach *",
  "Suggest activities": "Aktivitäten vorschlagen",
  "Suggestions applied to notes": "Vorschläge auf Notizen angewendet",
  "Tags (comma separated)": "Tags (durch Komma getrennt)",
  "Take": "Durchführen",
  "Taxonomy Levels (Webb 2005)": "Taxonomiestufen (Webb 2005)",
  "Teacher": "Lehrkraft",
  "Teacher Name": "Name der Lehrkraft",
  "Teacher name": "Name der Lehrkraft",
  "Technology": "Technik",
  "Template deleted": "Vorlage gelöscht",
  "Template name *": "Vorlagenname *",
  "Template saved!": "Vorlage gespeichert!",
  "Templates": "Vorlagen",
  "This will delete the class and all its students.": "Dadurch werden die Klasse und alle ihre Schüler gelöscht.",
  "To": "Bis",
  "To Grade": "Zu korrigieren",
  "Today's Schedule": "Heutiger Stundenplan",
  "Tools": "Werkzeuge",
  "Topic": "Thema",
  "Topic *": "Thema *",
  "Topic Summary": "Themenzusammenfassung",
  "Topic:": "Thema:",
  "Total Weight": "Gesamtgewichtung",
  "Tour": "Tour",
  "True": "Wahr",
  "True/False": "Wahr/Falsch",
  "Type your question...": "Geben Sie Ihre Frage ein...",
  "Upcoming Lessons": "Kommende Stunden",
  "Update Assignment": "Aufgabe aktualisieren",
  "Upload File": "Datei hochladen",
  "Upload a test or document": "Laden Sie einen Test oder ein Dokument hoch",
  "Uploading...": "Wird hochgeladen...",
  "Use proven templates or save your own successful plans": "Nutzen Sie bewährte Vorlagen oder speichern Sie Ihre eigenen erfolgreichen Pläne",
  "Use this template": "Diese Vorlage verwenden",
  "View": "Ansehen",
  "View All": "Alle ansehen",
  "View Assignments": "Aufgaben ansehen",
  "View starter templates": "Starter-Vorlagen ansehen",
  "Week 1": "Woche 1",
  "Week 1 - From": "Woche 1 - Von",
  "Week 1 - To": "Woche 1 - Bis",
  "Week 2": "Woche 2",
  "Week 2 - From": "Woche 2 - Von",
  "Week 2 - To": "Woche 2 - Bis",
  "Week Starts": "Wochenbeginn",
  "Week of": "Woche vom",
  "Weekly Prep Agent": "Wöchentlicher Vorbereitungsagent",
  "Weekly prep is ready!": "Die Wochenvorbereitung ist fertig!",
  "Welcome": "Willkommen",
  "What does CCSS.MATH.4.NF say?": "Was besagt CCSS.MATH.4.NF?",
  "Will save:": "Wird gespeichert:",
  "Working on:": "In Arbeit:",
  "Worksheet": "Arbeitsblatt",
  "Worksheets": "Arbeitsblätter",
  "Write the learning objectives...": "Schreiben Sie die Lernziele...",
  "You need an active subscription": "Sie benötigen ein aktives Abonnement",
  "You need an active subscription to use the AI assistant": "Sie benötigen ein aktives Abonnement, um den KI-Assistenten zu nutzen",
  "Your Request": "Ihre Anfrage",
  "Your digital classroom": "Ihr digitales Klassenzimmer",
  "Your saved lesson plans for easy access": "Ihre gespeicherten Unterrichtspläne für schnellen Zugriff",
  "assignments": "Aufgaben",
  "classes scheduled": "Stunden geplant",
  "days": "Tage",
  "days of activities": "Tage mit Aktivitäten",
  "en-US": "de-DE",
  "graded": "korrigiert",
  "of total": "von insgesamt",
  "points": "Punkte",
  "questions": "Fragen",
  "ready": "bereit",
  "students": "Schüler",
  "submissions": "Abgaben",
  "submissions pending": "ausstehende Abgaben",
  "used": "verwendet",
  "📅 Calendar file downloaded. Open it to add to Google Calendar, Outlook, or Apple Calendar.": "📅 Kalenderdatei heruntergeladen. Öffnen Sie sie, um sie zu Google Calendar, Outlook oder Apple Calendar hinzuzufügen.",
  "📅 Schedule (Optional)": "📅 Stundenplan (optional)",
  "📅 Weekly Plan (2 Weeks)": "📅 Wochenplan (2 Wochen)",
  "📗 Week 2": "📗 Woche 2",
  "📘 Week 1": "📘 Woche 1",
  "🗣️ Conversational English": "🗣️ Konversationsenglisch",
  "🗣️ Conversational English Plan Details": "🗣️ Details zum Konversationsenglisch-Plan"
};
